export default __webpack_public_path__ + "static/media/userColorful.45a1e22f.svg";